import s from './docs.module.css'
import ReportTable from "./ReportTable.jsx";
import RadioGroup from '../../old_components/baseComponents/RadioGroup'
import SaveStatus from '../../UIComponents/SaveStatus'
import {memo} from "react";

const DocsSecondRight = ({ data = [], loaderInfoSource }) => {
    return (
        <div className={s.docsContainer} style={{ width: "100%" }}>
            <RadioGroup />
            <div className={s.secondRightConrainer}>
                <div className={s.contentContainer}>
                    <SaveStatus errShowTime={1000} successShowTime={500} dataObj={loaderInfoSource} title="Загрузка данных"/>
                </div>
            </div>
            <div className={s.secondRightConrainer}>
                <div className={s.contentContainer}>
                    <ReportTable data={data}/>
                </div>
            </div>

        </div>
    );
};


export default memo(DocsSecondRight);